// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Title_wrap__YPALU","wrap-above":"Title_wrap-above__HTAeN","title-h2":"Title_title-h2__HeuZc","title-h3":"Title_title-h3__OYwFc","title-h4":"Title_title-h4__FKYz9"};